<template>
  <div class="material-card _pt-12 _px-8 _pb-6">
    <div class="material-card__icon _mb-6">
      <LinkVariant />
    </div>

    <h3
      class="material-card__title _fs-18 _lh-22 _fw-700 _mb-4"
      v-html="title"
    ></h3>

    <a target="_blank" :href="link" class="material-card__btn _py-2 _px-3">
      <span>{{ $t('interface.video.go') }}</span>
      <OpenInNew class="_ml-2" />
    </a>
  </div>
</template>

<script>
import OpenInNew from 'icons/OpenInNew'
import LinkVariant from 'icons/LinkVariant'

export default {
  name: 'MaterialCard',
  components: {
    OpenInNew,
    LinkVariant,
  },
  props: {
    title: String,
    link: String,
  },
}
</script>

<style lang="scss" scoped>
.material-card {
  flex-shrink: 0;
  width: 384px !important;
  background-color: color(white);
  border: 1px solid color(light);
  border-radius: 16px;
  height: 100%;

  @media screen and (max-width: 743px) {
    width: 280px !important;
  }

  &__icon {
    color: color(green-main);
  }

  &__title {
    color: color(dark);
  }

  &__btn {
    display: flex;
    align-items: center;
    width: fit-content;
    color: color(green-second);
    background-color: color(green-light);
    border-radius: 16px;
    cursor: pointer;
    transition: all 0.5s ease;

    &:hover {
      color: darken(color(green-second), 10);
      background-color: darken(color(green-light), 10);
    }
  }
}
</style>
